import { configureStore } from '@reduxjs/toolkit'
import { tableReducer } from '@aw/table'
import accountReducer from './slices/account'
import workspaceReducer from './slices/workspace'
import authTokenReducer from './slices/authToken'
import applicantDetailsReducer from '@/features/applicants/details/lib/slice/applicant-details'
import clientDetailsReducer from '@/features/clients/details/lib/slice/client-details'
import productTourReducer from '@/features/product-tour/lib/slice/product-tour'

export const store = configureStore({
    reducer: {
        account: accountReducer,
        workspace: workspaceReducer,
        authToken: authTokenReducer,
        table: tableReducer,
        applicantDetails: applicantDetailsReducer,
        clientDetails: clientDetailsReducer,
        productTour: productTourReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store